import React from "react";
import { Box, Text, Flex, Image, Link } from "@chakra-ui/react";

const GradientLine = () => {
  return (
    <Box
      position="relative"
      width={{base: "40%", md: "60%"}}
      height="6px"
      display="flex"
      alignItems="center"
    >
      <Box
        width="12px"
        height="12px"
        borderRadius="50%"
        backgroundColor="#BFBFBF"
        position="absolute"
        left="0"
        top="50%"
        transform="translateY(-50%)"
      />
      <Box
        width="100%"
        height="2px"
        marginLeft="10px"
        background="linear-gradient(to right, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%)"
      />
    </Box>
  );
};

const SocialItem = ({ text, link }) => {
  return (
  <Flex direction={"row"} gap={"8px"} as={Link} href={link} target="_blank"style={{textDecoration: "none"}}>
    <Box bgColor={"#fff"} borderRadius={"50%"} padding={"4px"} width={"32px"} height={"32px"}>
      <Image src={`/${text}.svg`} alt="logo" width="24px" height="24px" />
    </Box>
    <Text fontSize={"20px"} fontWeight={"400"} color={"#fff"} display={{ base: "none", md: "block" }}>
      {text}
    </Text>
  </Flex>
  )
};

const MessageBox = () => {
  return (
    <Box
      position="relative"
      display="inline-flex"
      alignItems="center"
      padding="6px 10px"
      fontSize="16px"
      color="white"
      mt={"70px"}
      borderRadius="12px"
      background="linear-gradient(270deg, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.05) 100%)"
      _before={{
        content: '""',
        position: "absolute",
        inset: "0",
        borderRadius: "12px",
        padding: "1px",
        background:
          "linear-gradient(to right, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.00) 100%)",
        WebkitMask:
          "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
      }}
      width={{base: "100%", md: "80%"}}
    >
      <Flex
        padding={"22px 36px"}
        direction={"column"}
        gap={"16px"}
        width={"100%"}
      >
        <Flex direction={"row"} gap={"16px"} alignItems={"center"}>
          <Text fontSize={"20px"} fontWeight={"400"} color={"#B6B6B6"}>
            Nasze Social Media
          </Text>
          <GradientLine />
        </Flex>
        <Flex direction={ "row"} gap={"24px"}>
          <SocialItem text={"Tiktok"} link={"https://www.tiktok.com/@socialprojectpl"} />
          <SocialItem text={"Instagram"} link={"https://www.instagram.com/socialproject.pl"}/>
          <SocialItem text={"Youtube"} link={"https://www.youtube.com/@Socialprojectpl"} />
        </Flex>
      </Flex>
    </Box>
  );
};

export default MessageBox;
